import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated');

  return isAuthenticated && restricted ? <Navigate to="/" /> : <Component {...rest} />;
};

PublicRoute.propTypes = {
  component: PropTypes.any,
  rest: PropTypes.any,
  // allowedRoles:PropTypes.arrayOf
  restricted: PropTypes.bool,
};
export default PublicRoute;
